import React, { Component } from "react";
import { clearErrors } from "../../actions/errorsActions";
import SideMenuOffices from "../../components/layout/SideMenuOffices";
import SideMenu from "../../components/layout/SideMenu";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Navigate from "../../components/Navigate/Navigate";
import AdminCards from "../../components/Cards/AdminCards";
import { getOffice } from "../../actions/officeActions";
import { accountType } from "../../enums/accountType";

import { withRouter } from "react-router-dom";
import { roles } from "../../enums/roles";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      mounted: false,
      auth: {},
      errors: {},
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let update = {};
    if (nextProps.auth) {
      if (nextProps.auth !== prevState.auth) {
        var tokenUserOffices = nextProps.auth.user.offices;
        update.singleOffice = tokenUserOffices && tokenUserOffices.length === 1 ? true : false;
        var usersRoleInOffice =
          nextProps.auth &&
          nextProps.auth.user.offices &&
          nextProps.auth.user.offices.filter((office) => office.id === parseInt(nextProps.match.params.officeId));
        update.usersRoleInOffice =
          usersRoleInOffice &&
          usersRoleInOffice[0] &&
          usersRoleInOffice[0].user_role_office &&
          usersRoleInOffice[0].user_role_office.role.value;
        if (!nextProps.auth.isAuthenticated || nextProps.auth.user.type !== accountType.USER) {
          // Not Authorized so redirecting to offices page which will redirect to landing
          nextProps.history.push(`/admin/offices`);
        } else {
          // Authorized and checking permission
          const result = nextProps.auth.user.offices.filter((office) => office.id === parseInt(nextProps.match.params.officeId));
          if (result.length === 0) {
            // No permission so returning to previous page
            nextProps.history.push(`/admin/offices`);
          }
        }
        if (nextProps.errors) {
          update.errors = nextProps.errors;
        }
        update.auth = nextProps.auth;
      }
    }
    return Object.keys(update).length ? update : null;
  }
  componentDidMount() {
    this.props.getOffice(this.props.match.params.officeId);
  }
  render() {
    var cards = [];
    if (roles.SUPERADMINISTRATOR === this.state.usersRoleInOffice || roles.ADMINISTRATOR === this.state.usersRoleInOffice) {
      cards = [
        {
          link: `/admin/${this.props.match.params.officeId}/candidates`,
          title: "Candidates",
          subtitle: "List of all candidates",
        },
        {
          link: `/admin/${this.props.match.params.officeId}/users`,
          title: "Users",
          subtitle: "List of all users",
        },
        {
          link: `/admin/${this.props.match.params.officeId}/questions`,
          title: "Questions",
          subtitle: "List of all branch questions",
        },
        {
          link: `/admin/${this.props.match.params.officeId}/global-questions`,
          title: "Global Questions",
          subtitle: "List of all global questions",
        },
        {
          link: `/admin/${this.props.match.params.officeId}/scenarios`,
          title: "Scenarios",
          subtitle: "List of all scenarios",
        },
        // {
        //   link: `/admin/${this.props.match.params.officeId}/recipients`,
        //   title: "Recipients",
        //   subtitle: "List of all exam status change email recipients",
        // },
        // {
        //   link: `/admin/${this.props.match.params.officeId}/difficulties`,
        //   title: "Difficulties",
        //   subtitle: "List of all difficulties",
        // },
        // {
        //   link: `/admin/${this.props.match.params.officeId}/categories`,
        //   title: "Categories",
        //   subtitle: "List of all categories",
        // },
        {
          link: `/admin/${this.props.match.params.officeId}/statistics`,
          title: "Statistics",
          subtitle: "Office candidate statistics",
        },
        {
          link: `/admin/${this.props.match.params.officeId}/settings`,
          title: "Settings",
          subtitle: "Office settings",
        },
      ];
    } else if (roles.GLOBALVIEWER === this.state.usersRoleInOffice) {
      cards = [
        {
          link: `/admin/${this.props.match.params.officeId}/candidates`,
          title: "Candidates",
          subtitle: "List of all candidates",
        },
        {
          link: `/admin/${this.props.match.params.officeId}/users`,
          title: "Users",
          subtitle: "List of all users",
        },
        {
          link: `/admin/${this.props.match.params.officeId}/questions`,
          title: "Questions",
          subtitle: "List of all branch questions",
        },
        {
          link: `/admin/${this.props.match.params.officeId}/global-questions`,
          title: "Global Questions",
          subtitle: "List of all global questions",
        },
        {
          link: `/admin/${this.props.match.params.officeId}/scenarios`,
          title: "Scenarios",
          subtitle: "List of all scenarios",
        },
        // {
        //   link: `/admin/${this.props.match.params.officeId}/recipients`,
        //   title: "Recipients",
        //   subtitle: "List of all exam status change email recipients",
        // },
        // {
        //   link: `/admin/${this.props.match.params.officeId}/difficulties`,
        //   title: "Difficulties",
        //   subtitle: "List of all difficulties",
        // },
        // {
        //   link: `/admin/${this.props.match.params.officeId}/categories`,
        //   title: "Categories",
        //   subtitle: "List of all categories",
        // },
        {
          link: `/admin/${this.props.match.params.officeId}/statistics`,
          title: "Statistics",
          subtitle: "Office candidate statistics",
        },
      ];
    } else if (roles.QA === this.state.usersRoleInOffice) {
      cards = [
        {
          link: `/admin/${this.props.match.params.officeId}/candidates`,
          title: "Candidates",
          subtitle: "List of all candidates",
        },
        {
          link: `/admin/${this.props.match.params.officeId}/users`,
          title: "Users",
          subtitle: "List of all users",
        },
        {
          link: `/admin/${this.props.match.params.officeId}/questions`,
          title: "Questions",
          subtitle: "List of all branch questions",
        },
        // {
        //   link: `/admin/${this.props.match.params.officeId}/global-questions`,
        //   title: "Global Questions",
        //   subtitle: "List of all global questions",
        // },
        // {
        //   link: `/admin/${this.props.match.params.officeId}/scenarios`,
        //   title: "Scenarios",
        //   subtitle: "List of all scenarios",
        // },
        // {
        //   link: `/admin/${this.props.match.params.officeId}/recipients`,
        //   title: "Recipients",
        //   subtitle: "List of all exam status change email recipients",
        // },
        // {
        //   link: `/admin/${this.props.match.params.officeId}/difficulties`,
        //   title: "Difficulties",
        //   subtitle: "List of all difficulties",
        // },
        // {
        //   link: `/admin/${this.props.match.params.officeId}/categories`,
        //   title: "Categories",
        //   subtitle: "List of all categories",
        // },
      ];
    } else if (roles.RECRUITER === this.state.usersRoleInOffice) {
      cards = [
        {
          link: `/admin/${this.props.match.params.officeId}/candidates`,
          title: "Candidates",
          subtitle: "List of all candidates",
        },
        {
          link: `/admin/${this.props.match.params.officeId}/users`,
          title: "Users",
          subtitle: "List of all users",
        },
        // {
        //   link: `/admin/${this.props.match.params.officeId}/questions`,
        //   title: "Questions",
        //   subtitle: "List of all branch questions",
        // },
        // {
        //   link: `/admin/${this.props.match.params.officeId}/global-questions`,
        //   title: "Global Questions",
        //   subtitle: "List of all global questions",
        // },
        {
          link: `/admin/${this.props.match.params.officeId}/scenarios`,
          title: "Scenarios",
          subtitle: "List of all scenarios",
        },
        // {
        //   link: `/admin/${this.props.match.params.officeId}/recipients`,
        //   title: "Recipients",
        //   subtitle: "List of all exam status change email recipients",
        // },
        // {
        //   link: `/admin/${this.props.match.params.officeId}/difficulties`,
        //   title: "Difficulties",
        //   subtitle: "List of all difficulties",
        // },
        // {
        //   link: `/admin/${this.props.match.params.officeId}/categories`,
        //   title: "Categories",
        //   subtitle: "List of all categories",
        // },
        {
          link: `/admin/${this.props.match.params.officeId}/statistics`,
          title: "Statistics",
          subtitle: "Office candidate statistics",
        },
      ];
    }
    return (
      <div className="grid-menu-container">
        <div className="menu-grid">
          <div className="menu">
            <SideMenuOffices props={this.props} />
            <hr />
            <SideMenu props={this.props} />
          </div>
        </div>
        <div className="main-grid">
          <div className="main">
            <Navigate title={"Dashboard"} />
            <AdminCards cards={cards} />
          </div>
        </div>
      </div>
    );
  }
}

Dashboard.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
  offices: state.offices,
});

export default connect(mapStateToProps, { getOffice, clearErrors })(withRouter(Dashboard));
